import { useMutation } from "@apollo/react-hooks";

import { Learner, Test } from "@hubcapp/types";
import testDetails from "../graph-ql/testDetails.graphql";
import updateTestMutation from "../graph-ql/updateTest.graphql";

const useMutationUpsertTest = (instructorId: string, learnerId: string) =>
  useMutation(updateTestMutation, {
    optimisticResponse: (variables: Test & { learnerId: string }) => ({
      updateTest: { ...variables, __typename: "Test" },
    }),
    update: (proxy, { data }) => {
      if (data) {
        const learnerQuery = proxy.readQuery<{ learner: Learner }>({
          query: testDetails,
          variables: {
            id: learnerId,
            instructorId,
          },
        });

        if (learnerQuery) {
          const exists = learnerQuery.learner.tests
            .map(({ id }) => id)
            .includes(data.updateTest.id);

          if (exists) {
            return;
          }

          proxy.writeQuery({
            query: testDetails,
            variables: {
              id: learnerId,
              instructorId,
            },
            data: {
              learner: {
                ...learnerQuery.learner,
                tests: [...learnerQuery.learner.tests, data.updateTest],
              },
            },
          });
        }
      }
    },
  });

export default useMutationUpsertTest;
